import { nextTick } from 'vue';

// --- DEFINE YOUR DEFAULTS IN ONE PLACE ---
const DEFAULT_SITE_TITLE = 'YOKO.dk';
const DEFAULT_DESCRIPTION = 'Oplev og køb unik kunst og design direkte fra danske kunstnere.';

/**
 * Strips HTML tags from a string for use in meta descriptions.
 * @param {string} html - The HTML string to clean.
 * @returns {string} The plain text.
 */
function stripHtml(html) {
    if (!html) return '';
    // Create a temporary element to parse the HTML
    const tempEl = document.createElement('div');
    tempEl.innerHTML = html;
    // Return its text content, trimmed
    return (tempEl.textContent || tempEl.innerText || '').trim();
}

/**
 * Updates the document's title and meta description.
 * @param {string} [title] - The new page title.
 * @param {string} [description] - The new meta description (HTML will be stripped).
 */
export function updateMeta(title, description) {
    // Use the provided title or fall back to the default
    const pageTitle = title ? `${title} | ${DEFAULT_SITE_TITLE}` : DEFAULT_SITE_TITLE;

    // Clean the description and trim it
    let cleanDescription = stripHtml(description);
    const pageDescription = cleanDescription.substring(0, 160) || DEFAULT_DESCRIPTION; // Trim to 160 chars

    // Wait for the DOM to be ready before updating
    nextTick(() => {
        document.title = pageTitle;

        // Find or create the meta description tag
        let descriptionEl = document.querySelector('meta[name="description"]');
        if (!descriptionEl) {
            descriptionEl = document.createElement('meta');
            descriptionEl.setAttribute('name', 'description');
            document.head.appendChild(descriptionEl);
        }
        // Set its content
        descriptionEl.setAttribute('content', pageDescription);
    });
}